// extracted by mini-css-extract-plugin
module.exports = {"Overlay":"Modal_Overlay__2AxMb","Modal":"Modal_Modal__2WBTT"};